import { FETCH_DEVICES } from './constants'

const initialState = {
  isFetching: true,
  devices: []
}

export default function devicesReducer(state = initialState, action) {
  switch (action.type) {
    case FETCH_DEVICES.REQUEST: {
      return {
        ...state,
        isFetching: true
      }
    }
    case FETCH_DEVICES.SUCCESS: {
      return {
        ...state,
        isFetching: false,
        devices: action.devices
      }
    }
    default: {
      return state
    }
  }
}
